<template>
  <v-btn
    depressed
    rounded
    outlined
    class="niko-button"
    :class="primary && 'primary niko-button-primary'"
    @click="$emit('onClick')"
    height="40px"
    :text="false"
    v-bind="$props"
  >
    <v-icon v-if="!!iconBefore" class="mr-2">{{ iconBefore }}</v-icon>

    {{ text }}

    <v-icon v-if="!!iconAfter" class="ml-2">{{ iconAfter }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "niko-button",
  props: {
    type: { default: "button" },
    text: String,
    width: String,
    disabled: Boolean,
    id: String,
    iconBefore: String,
    iconAfter: String,
    primary: Boolean,
    to: String,
    href: String,
    target: String,
  },
};
</script>

<style lang="scss">
.niko-button {
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  padding: 0 24px !important;
}
.v-application .secondary {
  background-color: var(--v-secondary-base) !important;
  border: thin solid rgba(255, 255, 255, 0.5) !important;
}
.niko-button-primary {
  color: var(--v-accent-darken3) !important;
}

.niko-button-primary:hover {
  background-color: var(--v-primary-darken1) !important;
}

.v-icon.v-icon {
  -webkit-appearance: none;
}
</style>
